import axios from "axios";
import React, { useState, useEffect } from "react";
import { HubConnectionBuilder, JsonHubProtocol } from "@microsoft/signalr";
import ControllerGroup from "./Components/ControllerGroup";
import ManualSwitchTrigger from "./Components/TriggerRows/ManualSwitchTrigger";
import LotReservationTrigger from "./Components/TriggerRows/LotReservationTrigger";
import AreaTrigger from "./Components/TriggerRows/AreaTrigger";
import {useTranslation} from "react-i18next";

const StateControllerService = (props) => {
  const { t } = useTranslation();
  const [stateController, setStateController] = useState([]);
  const [stateControllerGroups, setStateControllerGroups] = useState([]);
  const [token] = useState(localStorage.getItem("JWT"));
  const activeRights = JSON.parse(localStorage.getItem("rights"));
  const userCanEdit = activeRights.includes("StateControllerService.Update");
  const link = localStorage.getItem("link");

  let hubConnection = new HubConnectionBuilder()
    .withUrl(link + "/ws/elementHub", {
      accessTokenFactory: () => token,
    })
    .withAutomaticReconnect()
    .withHubProtocol(new JsonHubProtocol())
    .build();

  function loadController() {
    axios
      .get(link + "/api/StateController")
      .then((response) => {
        console.debug("Loaded StateController from API", response.data);
        setStateController(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }

    function loadGroups() {
        axios
            .get(link + "/api/StateController/Groups")
            .then((response) => {
                console.debug("Loaded StateController Groups from API", response.data);
                setStateControllerGroups(response.data);
            })
            .catch((error) => { console.error(error); });
    }

    function setAreaTriggerValue(controllerId, areaId, value) {
        if (!userCanEdit) {
            return;
        }
        axios
            .put(link + `/api/StateController/SetAreaTriggerValue?controllerId=${parseInt(controllerId)}&areaId=${parseInt(areaId)}&triggerValue=${parseInt(value)}`)
            .catch((error) => { console.error(error); });
    }

    function setAreaTriggerHysteresis(controllerId, areaId, hysteresis) {
        if (!userCanEdit) {
            return;
        }
        axios
            .put(link + `/api/StateController/SetAreaTriggerHysteresis?controllerId=${parseInt(controllerId)}&areaId=${parseInt(areaId)}&hysteresis=${parseFloat(hysteresis.replace(',', '.'))}`)
            .catch((error) => { console.error(error); });
    }
    
    function setManualTrigger(controllerId, active){
        if (!userCanEdit) {
            return;
        }
        axios
            .put(link + `/api/StateController/SetManualTriggerActive?controllerId=${parseInt(controllerId)}&active=${active}`)
            .catch((error) => { console.error(error); });
    }

    useEffect(() => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('JWT');
        loadGroups();
        loadController();

        hubConnection
            .start()
            .then((result) => {
                console.debug("Hub Connection changed %o", result);
                hubConnection.invoke("RegisterStateControllerUpdates");
            });

        console.log("Registering StateControllerChanged WebSocket Hook");
        hubConnection.on("StateControllerChanged", (jsonString) => {
            try {
                let controller = JSON.parse(jsonString);
                let controllerId = controller.id;
                console.debug("Received StateControllerChanged for Controller %s / %i: %o", controller.name, controllerId, controller);

                setStateController(prev =>
                    prev.map(item => item.id === controllerId ? controller : item)
                );
            } catch (error) {
                console.error("Error while processing Controller Changed Event", error);
            }
        });
    }, []);

    const TriggerRows = ({trigger, controllerId}) => {
        return trigger.map((inputTrigger) => {
            switch (inputTrigger.$type) {
                case "lotreservationtrigger":
                    return (<LotReservationTrigger trigger={inputTrigger} />)
                case "areatrigger":
                    return (
                        <AreaTrigger 
                            trigger={inputTrigger} 
                            controllerId={controllerId}
                            canUpdate={activeRights.includes('StateControllerService.Update')}
                            setAreaTriggerValue={(areaId, value) => setAreaTriggerValue(controllerId, areaId, value)}
                            setAreaTriggerHysteresis={(areaId, value) => setAreaTriggerHysteresis(controllerId, areaId, value)}
                    />)
                case "manualswitchtrigger":
                    return (
                        <ManualSwitchTrigger
                            trigger={inputTrigger}
                            canUpdate={activeRights.includes('StateControllerService.Update')}
                            update={(activate) => setManualTrigger(controllerId, activate)}
                    />)
                default:
                    return (
                        <tr>
                            <td colSpan={2}>{JSON.stringify(inputTrigger)}</td>
                        </tr>
                    )
            }
        });
    }

    return (
        <div className="pagewrapper-2">
            <div className="left-container-se left-part-carfinder" >
                {stateControllerGroups.map((group) => (
                    <ControllerGroup 
                        group={group}
                        allController={stateController}
                        onSelectController={(id) => setManualTrigger(id, true)}
                        activeRights={activeRights}
                    />
                ))}

                {stateController.map((controller) => (
                    <div className="einstellungen-box" style={{ width: "30%", margin: "10px", marginBottom: "30px" }}>
                        <div className="box-name">
                            {controller.name}
                        </div>
                        <div style={{ overflow: "auto" }}>
                            <table style={{ "width": "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>{t("stateControllerService.activated")}</td>
                                        <td>{controller.outputsActive === true ? t("allgemein.ja") : t("allgemein.nein")}</td>
                                    </tr>
                                    <TriggerRows trigger={controller.inputTriggerModels} controllerId={controller.id} />
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default StateControllerService
